import type { SalesforcePaymentsExpressConfig } from '../../types/config';
import type { PaymentIntentRequest } from '../../types/paymentRequest';
import type { ExpressType, PaymentMethodSet } from '../../types/paymentMethodSet';
import { ComponentType, PaymentMode } from '../../types/paymentMethodSet';
import { addClass } from '../../util/utility';
import { Component } from '../component';
import type { SfPaymentMethodComponent } from '../../vendor/sfp-payment-method-component';
import type SfpContext from '../../sfp-context';
import type { MetadataReader } from '../../util/metadata-reader';
import { checkAmount } from '../../util/preconditions';

export class Express extends Component {
  TYPE = ComponentType.EXPRESS;

  type: ExpressType;
  config: SalesforcePaymentsExpressConfig;
  paymentRequest: PaymentIntentRequest;

  /**
   * @class Express
   * @hideconstructor
   * @classdesc Express component presenting a selection of payment methods determined by the payment method set and related configuration.
   * @extends Component
   * @public
   */
  constructor(
    context: SfpContext,
    metadataReader: MetadataReader,
    paymentMethodSet: PaymentMethodSet,
    config: SalesforcePaymentsExpressConfig,
    paymentRequest: PaymentIntentRequest,
    elementOrSelectorToMountTo: string | HTMLElement,
    expressType: ExpressType
  ) {
    super(
      context,
      PaymentMode.EXPRESS,
      metadataReader,
      paymentMethodSet,
      config,
      paymentRequest,
      elementOrSelectorToMountTo
    );
    this.type = expressType;
  }

  async updateAmount(amount: number): Promise<void> {
    checkAmount(amount, 'amount');

    // Update each of the components
    await Promise.allSettled(this.components.map((component) => component.updateAmount(amount)));

    // Set the updated amount in the payment request
    this.paymentRequest.amount = amount;
  }

  protected stylePaymentElement(): void {
    super.stylePaymentElement();
    addClass(this.paymentElement, 'sfpp-component-express');
    if (this.config.options.maximumButtonCount != null) {
      addClass(this.paymentElement, 'sfpp-component-express-limited-buttons');
      addClass(this.paymentElement, `sfpp-maximum-buttons-${Math.trunc(this.config.options.maximumButtonCount)}`);
    }
  }

  protected shouldAddComponent(paymentComponent: SfPaymentMethodComponent): boolean {
    if (!paymentComponent || !paymentComponent.element) {
      // Component must have body element
      return false;
    }
    return true;
  }
}
